import { AudioT } from 'components/shared/audio/api/types';

import AnnouncementAdapter, { AnnouncementItem } from './announcementAdapter';
import WaitMusicAdapter from './waitMusicAdapter';

export enum AdapterTypes {
  WaitMusic,
  Announcement,
}

export interface Item {
  id: string;
  name: string;
  url: string;
}

export interface Adapter {
  getItemForCallback: (id: string) => AudioT | AnnouncementItem | undefined;
  getFormattedItem: (item: AudioT | AnnouncementItem) => Item | undefined;
  getItemFromURL: (url: string) => Item | undefined;
  getItems: () => Promise<Item[]>;
  upload: (file: File) => Promise<string>;
}

export type AdapterItemType = AudioT | AnnouncementItem;

export type AdapterCallbackItem = {
  [AdapterTypes.WaitMusic]: AudioT;
  [AdapterTypes.Announcement]: AnnouncementItem;
};

export const getAdapter = (adapterName: AdapterTypes): Adapter => {
  switch (adapterName) {
    case AdapterTypes.WaitMusic:
      return new WaitMusicAdapter();
    case AdapterTypes.Announcement:
      return new AnnouncementAdapter();
    default:
      throw new Error('Adapter not specified');
  }
};
